//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Features/Features.ShipDesign.ManufacturingStockBuilder.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Features.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Weld.js";
let d=[[[0,"AngularTolerance",1,0],[0,"CreateAssociativeMirror",1,0],[0,"DistanceTolerance",1,0],[0,"FromTargetPlate",1,0],[0,"InheritParentPlateMaterial",1,0],[0,"InstallDirection",1,0],[1,"IntersectedStiffener",0,"SelectNXObjectList",0],[1,"ManufacturingStock",0,"Features.ShipDesign.ManufacturingStockBuilder",0],[0,"ProfileCutout",0,"ScCollector",0],[1,"SectionData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[0,"SquareCut",1,0],[1,"WeldCharacteristics",0,"Weld.CharacteristicsBuilder",0]],[[["numFeats","featObjects"],"AskCreatedFeatures",{},0,0],[[],"UpdateCollarPlateSizeInformation",{},0,0]],[]];
SPLM.Features.ShipDesign.CollarPlateBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CollarPlateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;